export default {"src":"/_next/static/media/MFO-main-logo-White.95fa8e4a.svg","height":32,"width":175,"blurWidth":0,"blurHeight":0};